import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index'
import cache from './assets/lib/cache'
import report from './model/report'
import { Message } from 'element-ui'
import comm from './assets/lib/comm'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: { data: 'basic' }
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/subject',
      name: 'subject',
      component: () =>
        import(/* webpackChunkName: "subject" */ './views/subject/Subject.vue'),
      meta: { data: 'basic' }
    },
    {
      path: '/notify',
      name: 'notify',
      component: () =>
        import(/* webpackChunkName: "notify" */ './views/notify/Notify.vue'),
      meta: { data: 'basic' }
    },
    {
      path: '/notify/:id',
      name: 'notifyDetail',
      component: () =>
        import(
          /* webpackChunkName: "notify_detail" */ './views/notify/NotifyDetail.vue'
        ),
      props: (route) => ({ notify: route.params.notify })
    },
    {
      path: '/notice/:type',
      name: 'notice',
      component: () =>
        import(/* webpackChunkName: "notice" */ './views/notice/Notice.vue'),
      props: (route) => ({ noticeType: route.params.type }),
      meta: { data: 'basic' }
    },
    {
      path: '/notice/detail/:id',
      name: 'noticeDetail',
      component: () =>
        import(
          /* webpackChunkName: "notice_detail" */ './views/notice/NoticeDetail.vue'
        ),
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/scene',
      name: 'scene',
      component: () =>
        import(/* webpackChunkName: "scene" */ './views/scene/Scene.vue'),
      meta: { data: 'basic' }
    },
    {
      path: '/scene/add',
      name: 'sceneAdd',
      component: () =>
        import(
          /* webpackChunkName: "scene-add" */ './views/scene/SceneAdd.vue'
        ),
      meta: { data: 'basic' },
      props: (route) => ({
        sceneId: parseInt(route.query.sceneId) || 0,
        type: parseInt(route.query.type) || 0
      })
    },
    {
      path: '/device',
      component: () =>
        import(/* webpackChunkName: "device" */ './views/device/Device.vue'),
      meta: { data: 'basic' },
      children: [
        {
          path: '',
          name: 'device',
          component: () =>
            import(
              /* webpackChunkName: "device" */ './views/device/DevicePublic.vue'
            )
        },
        {
          path: 'devicegroup',
          name: 'devicegroup',
          component: () =>
            import(
              /* webpackChunkName: "devicegroup" */ './views/device/DeviceGroup.vue'
            )
        },
        {
          path: 'light',
          name: 'light',
          component: () =>
            import(
              /* webpackChunkName: "light" */ './views/device/DeviceLight.vue'
            )
        },
        {
          path: 'aircon',
          name: 'aircon',
          component: () =>
            import(
              /* webpackChunkName: "aircon" */ './views/device/DeviceAir.vue'
            )
        },
        {
          path: 'curtain',
          name: 'curtain',
          component: () =>
            import(
              /* webpackChunkName: "curtain" */ './views/device/DeviceCurtain.vue'
            )
        },
        {
          path: 'door_lock',
          name: 'door_lock',
          component: () => import(/* webpackChunkName: "curtain" */ './views/device/DeviceDoorLock.vue')
        },
        {
          path: 'airpure',
          name: 'airpure',
          component: () =>
            import(
              /* webpackChunkName: "airpure" */ './views/device/DeviceAirpure.vue'
            )
        },
        {
          path: 'fan',
          name: 'fan',
          component: () =>
            import(
              /* webpackChunkName: "fan" */ './views/device/DeviceFan.vue'
            )
        },
        {
          path: 'switch',
          name: 'switch',
          component: () =>
            import(
              /* webpackChunkName: "switch" */ './views/device/DeviceSwitch.vue'
            )
        },
        {
          path: 'video',
          name: 'video',
          component: () =>
            import(
              /* webpackChunkName: "video" */ './views/device/DeviceVideo.vue'
            )
        },
        {
          path: 'screen',
          name: 'screen',
          component: () =>
            import(
              /* webpackChunkName: "screen" */ './views/device/DeviceScreen.vue'
            )
        },
        {
          path: 'airswitch',
          name: 'airswitch',
          component: () =>
            import(
              /* webpackChunkName: "video" */ './views/device/DeviceWisdom.vue'
            )
        },
        {
          path: 'lora_aircon',
          name: 'lora_aircon',
          component: () =>
            import(
              /* webpackChunkName: "video" */ './views/device/DeviceLoraaircon.vue'
            )
        }
        // {
        //   path: "light_class",
        //   name: "light_class",
        //   component: () => import(/* webpackChunkName: "curtain" */ "./views/device/DeviceLightClass.vue"),
        // },
      ]
    },
    {
      path: '/aircon/:id',
      name: 'aircondition',
      component: () =>
        import(
          /* webpackChunkName: "aircon" */ './views/device/AirCondition.vue'
        ),
      props: (route) => ({ device: route.params.device })
    },
    {
      path: '/loraaircon/:id',
      name: 'loraaircondition',
      component: () =>
        import(
          /* webpackChunkName: "aircon" */ './views/device/LoraAirCondition.vue'
        ),
      props: (route) => ({ device: route.params.device })
    },
    {
      path: '/light/:id',
      name: 'lightDetail',
      component: () =>
        import(/* webpackChunkName: "light" */ './views/device/Light.vue'),
      props: (route) => ({ device: route.params.device })
    },
    {
      path: '/colorbar/:id',
      name: 'colorbarDetail',
      component: () =>
        import(
          /* webpackChunkName: "colorbar" */ './views/device/ColorBar.vue'
        ),
      props: (route) => ({ device: route.params.device })
    },
    {
      path: '/user',
      name: 'user',
      component: () =>
        import(/* webpackChunkName: "user" */ './views/user/User.vue'),
      meta: { color: '#35BD64' }
    },
    {
      path: '/user/device',
      name: 'deviceSetting',
      component: () =>
        import(/* webpackChunkName: "user" */ './views/user/DeviceSetting.vue')
    },
    {
      path: '/user/device/list',
      name: 'deviceList',
      component: () =>
        import(
          /* webpackChunkName: "user-device" */ './views/user/DeviceList.vue'
        )
    },
    {
      path: '/user/device/edit',
      name: 'deviceEdit',
      component: () =>
        import(
          /* webpackChunkName: "user-device" */ './views/user/DeviceEdit.vue'
        ),
      props: (route) => ({ device: route.params.device })
    },
    {
      path: '/user/scene',
      name: 'sceneSetting',
      component: () =>
        import(/* webpackChunkName: "user" */ './views/user/SceneSetting.vue')
    },
    {
      path: '/user/linkage',
      name: 'linkAgeSetting',
      component: () =>
        import(
          /* webpackChunkName: "user" */ './views/user/LinkAgeSetting.vue'
        )
    },
    {
      path: '/user/linkage/edit',
      name: 'LinkAgeEdit',
      component: () =>
        import(/* webpackChunkName: "user" */ './views/user/LinkAgeEdit.vue')
    },
    {
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ './views/404.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  try {
    comm.showLoading()
    // 判断还否需要登录
    if (to.name === 'login') {
      next()
    } else if (cache.getSession('dtit_user')) {
      // 进行必要的数据检查，并在检查后进行加载
      next()
    } else {
      next('/login')
    }
  } catch (e) {
    Message.error('系统异常，请联系管理员')
    next('/login')
  }
})

router.afterEach((to, from) => {
  if (window.vm) {
    window.vm.$store.commit('CHANGE_ACTIVE_TOOLMENUS', to.name)
    window.vm.$store.commit('CHANGE_ACTIVE_DEVICEMENUS', to.name)
    if (to.path.indexOf('device') > -1) {
      window.vm.$store.commit('CHANGE_ACTIVE_TOOLMENUS', 'device')
    }
    // 统计代码
    report.tracePage()
  }
  comm.closeLoading()
  // 设置头部颜色
  setHeaderColor(to.meta && to.meta.color)
})

function setHeaderColor (color) {
  const tags = document.getElementsByTagName('meta')
  for (let i = 0; i < tags.length; i++) {
    if (
      tags[i].name &&
      tags[i].name === 'apple-mobile-web-app-status-bar-style'
    ) {
      tags[i]['content'] = color || 'white'
    }
  }
}

export default router
